import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Space, Spin, message } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "../../../../components/utils/Interceptors";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const { Option } = Select;

const OtherTab = ({ otherInfo }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (otherInfo) {
      form.setFieldsValue({ social: otherInfo });
    }
  }, [otherInfo, form]);

  const onFinish = async (values) => {
    setLoading(true);
    const { social } = values;
    const other_icon = social.map((item) => item.icon);
    const other_url = social.map((item) => item.url);
    const other_name = social.map((item) => item.icon);

    const newData = {
      other_icon,
      other_url,
      other_name,
    };

    try {
      const baseUrl = process.env.REACT_APP_APIURL;

      const res = await axios.patch(
        `${baseUrl}/vendor/updatestoredetails`,
        JSON.stringify(newData),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      const response = await res.data;
      if (response.status_code === 200) {
        toast.success("Updated Successfully!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("An error occurred while updating.");
    }
    setLoading(false);
  };

  const removeIcon = async (id, remove, name) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_APIURL}/vendor/removeSocialMedia`,
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      remove(name);
    } catch (error) {
      toast.error("Failed to remove social media link.");
    }
  };

  return (
    <Spin spinning={loading}>
      <Form
        form={form}
        name="other_tab"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
      >
        <Form.List name="social">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => {
                const currentItem = form.getFieldValue(["social", name]);
                const id = currentItem?.id;

                return (
                  <Space
                    key={key}
                    style={{ display: "flex", marginBottom: 8 }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "url"]}
                      fieldKey={[fieldKey, "url"]}
                      rules={[{ required: true, message: "Missing URL" }]}
                    >
                      <Input placeholder="URL" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "icon"]}
                      fieldKey={[fieldKey, "icon"]}
                      rules={[{ required: true, message: "Missing Icon" }]}
                    >
                      <Select placeholder="Select Social Media">
                        <Option value="fa-brands fa-facebook">Facebook</Option>
                        <Option value="fa-brands fa-instagram">Instagram</Option>
                        <Option value="fa-brands fa-youtube">YouTube</Option>
                        <Option value="fa-brands fa-linkedin">LinkedIn</Option>
                      </Select>
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() =>
                        id
                          ? removeIcon(id, remove, name)
                          : remove(name)
                      }
                    />
                  </Space>
                );
              })}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  {t("Add New")}
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.Item>
          <button className="btn btn-primary text-white" type="primary" htmlType="submit">
            {t("vd_pc_btn")}
          </button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default OtherTab;
